export enum SelectionSectorType {
  ENTIRE = "entire",
  ROW = "row",
  COLUMN = "column",
}